"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FeaturedCaseStudies() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const caseStudies = [{
    id: 1,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1477031/img/financial_management_turnaround_case.png",
    title: "Financial Management Turnaround",
    outcome: "Helped a mid-size enterprise reduce operational costs by 30% through strategic financial planning and process optimization.",
    link: "#"
  }, {
    id: 2,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1477031/img/startup_growth_strategy_case.png",
    title: "Startup Growth Strategy",
    outcome: "Guided an emerging entrepreneur from concept to market launch with a clear roadmap, achieving profitability within 18 months.",
    link: "#"
  }, {
    id: 3,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1477031/img/operational_efficiency_improvement_case.png",
    title: "Operational Efficiency Improvement",
    outcome: "Streamlined business operations for a small enterprise, resulting in a 40% improvement in productivity and client satisfaction.",
    link: "#"
  }];
  const refs = [ref1, ref2, ref3];
  const visibilities = [isVisible1, isVisible2, isVisible3];
  return <section className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-primary mb-4">Featured Case Studies</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Explore real-world examples of how RESTORE AND HOPE LLC has guided businesses to overcome challenges and achieve sustainable growth.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {caseStudies.map((study, i) => <div key={study.id} data-index={i} ref={refs[i]} className={`group transition-all duration-300 ${visibilities[i] ? "animate-fade-in-up" : "opacity-0"}`} style={{
          animationDelay: `${i * 100}ms`
        }}>
              <Card className="h-full overflow-hidden relative card hover-lift">
                <div className="relative overflow-hidden">
                  <img src={study.image} alt={study.title} className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/15 transition-all duration-300" />
                </div>

                <CardHeader className="relative">
                  <CardTitle className="text-xl transition-transform duration-300 group-hover:-translate-y-1">
                    {study.title}
                  </CardTitle>
                </CardHeader>

                <CardContent className="flex-grow">
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {study.outcome}
                  </p>
                </CardContent>

                <CardFooter>
                  <Link to={study.link} className="w-full">
                    <Button variant="outline" className="w-full transition-transform duration-150 hover:scale-105 focus-ring">
                      View Case Study
                    </Button>
                  </Link>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}